import { render, staticRenderFns } from "./PhoneNumberCard.vue?vue&type=template&id=57148d33&scoped=true&"
import script from "./PhoneNumberCard.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57148d33",
  null
  
)

export default component.exports